import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Male Bacterial Vaginosis treatment type.
 */
export const MaleBvTreatment = new TreatmentType({
  id: '11',
  name: ConsultationTreatmentTypes.MaleBv,
  genderSettings: new TreatmentGenderSettings({
    disallowed: [Gender.Female],
    errorMessage:
      "If you're a female seeking treatment for Bacterial Vaginosis (BV), please visit our <a href='https://www.starfish.com/bv-antibiotics/'>Female BV Treatment page</a>.",
  }),
});
